export const USER_ME_QUERY_KEY = "user-me";
export const USER_PROFILE_QUERY_KEY = "user-profile";
export const USER_PROFILE_PHOTO_QUERY_KEY = "user-profile-photo";

export const PERMISSIONS = {};
